import {
  Button,
  Typography,
  Box,
  styled,
  CircularProgress,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Stack,
} from "@mui/material";
import {
  DataGrid,
  GridColDef,
  GridToolbar,
  GridPaginationModel,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridOverlay,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

import ToastSnackbar, { SnackbarHandle } from "../../common/ToastNotification";
import HomeIcon from "@mui/icons-material/Home";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import React, { useRef, useState } from "react";
import { useForm } from "react-hook-form";
import ControlledTextField from "../../common/ControlledComponents/ControlledTextField";
import moment from "moment";
import { GetFeeCollectionRecordsDateWise } from "../../api/Report-Center/fee-collection";
import { GetHeadWiseFeeCollectionReportDateWise } from "../../api/Report-Center/fee-collection";
// import { GetCurrentAcademciSession } from "../../helper/helper";
import { toWords } from "number-to-words";
import { useApi } from "../../store/UserLoginContext";

const MyCustomButton = styled(Button)(({ theme }) => ({
  fontFamily: "Motiva Sans Bold",
  fontSize: "0.80rem",
  fontWeight: "700",
  border: "1px solid #edf3f5",
  borderRadius: "4px",
  background: "#2e186a",
  boxShadow: "0 16px 30px rgb(23 31 114 / 20%)",
  marginTop: "0rem",
  "&:hover": {
    color: "#fff",
    border: "1px solid rgb(255, 130, 92)",
    backgroundColor: "rgb(255, 130, 92)",
  },
}));

const StyledTableCell = styled(TableCell)({
  border: "1px solid black",
  padding: "4px",
  textAlign: "center",
});

const StyledTableCellErrored = styled(TableCell)({
  border: "2px solid black",
  padding: "4px",
  textAlign: "center",
  color: "error",
});

const FeeCollection = () => {
  const { currentSessionAY } = useApi();
  const tableRefs = useRef([]);
  const snackbarRef = React.useRef<SnackbarHandle>(null);
  const navigate = useNavigate();
  const [fetchingReport, setFetchingReport] = useState(false);
  const [gettingReport, setGettingReport] = useState(false);
  const [applications, setApplications] = useState<any>([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalAmountByUser, setTotalAmountByUser] = useState(0);
  const [generatePdf, setGeneratePdf] = useState(false);
  const [paginationModel, setPaginationModel] =
    React.useState<GridPaginationModel>({ page: 0, pageSize: 50 });
  const [reportDate, setReportDate] = useState({
    start_date: "",
    end_date: "",
  });
  const [getHeadWiseReport, setGetHeadWiseReport] = useState(false);

  const {
    handleSubmit,
    control,
    formState: { errors },
    trigger,
    reset,
  } = useForm({
    defaultValues: {
      start_date: "",
      end_date: "",
    },
    mode: "onTouched",
    shouldUnregister: false, // Prevents unnecessary re-renders
  });
  const FetchReportHandler = async (data: any) => {
    try {
      if (getHeadWiseReport) {
        setGettingReport(true);

        const start_date = moment(data.start_date)
          .format("YYYY-MM-DD")
          .toString();
        const end_date = moment(data.end_date).format("YYYY-MM-DD").toString();
        const payload = {
          start_date,
          end_date,
          academic_year: currentSessionAY,
        };
        console.log(start_date, end_date);

        const response = await GetHeadWiseFeeCollectionReportDateWise(payload);
        console.log("***********response*************");
        console.log(response);
        if (response && response?.status && response?.status === "NO_RECORDS") {
          snackbarRef.current?.showSnackbar(`${response?.message}`, "warning");
        }
      } else {
        setFetchingReport(true);
        setApplications([]);
        setTotalAmountByUser(0);
        setGeneratePdf(false);
        setTotalAmount(0);

        const start_date = moment(data.start_date)
          .format("DD-MM-YYYY")
          .toString();
        const end_date = moment(data.end_date).format("DD-MM-YYYY").toString();
        const payload = {
          start_date,
          end_date,
        };

        const response = await GetFeeCollectionRecordsDateWise(payload);
        if (response && response.result && response.result?.length > 0) {
          const validRecords = response.result.filter(
            (item: any) => item.payment_status !== "Cancelled"
          );

          const totalAmountPaid = validRecords.reduce(
            (sum: any, record: any) =>
              parseInt(sum) + parseInt(record.amount_paid),
            0
          );

          const groupedByUser = validRecords.reduce((acc: any, record: any) => {
            acc[record.user] =
              parseInt(acc[record.user] || 0) + parseInt(record.amount_paid);
            return acc;
          }, {});
          setReportDate(payload);
          setTotalAmount(totalAmountPaid);
          setApplications(response.result);
          setTotalAmountByUser(groupedByUser);
          snackbarRef.current?.showSnackbar(
            `${response.result?.length} No of Records Fetched`,
            "success"
          );
        } else {
          snackbarRef.current?.showSnackbar(`No Records Found`, "info");
        }
        console.log(response);
      }
    } catch (error) {
      console.log(error);
      snackbarRef.current?.showSnackbar(`Some Error Occured`, "error");
    } finally {
      setFetchingReport(false);
      setGettingReport(false);
    }
  };

  const onResetHandler = () => {
    reset({
      start_date: "",
      end_date: "",
    });
    setApplications([]);
    setTotalAmountByUser(0);
    setGeneratePdf(false);
    setTotalAmount(0);
  };

  const columns: GridColDef[] = [
    { field: "receipt_no", headerName: "Rcpt No.", flex: 1 },
    {
      field: "admission_id",
      headerName: "Adm No.",
      flex: 1,
      valueGetter: (_, row) => {
        return row.admission_id.toString().padStart(5, "0");
      },
    },
    { field: "personal_details", headerName: "Student Name", flex: 1 },
    { field: "class_name", headerName: "Class", flex: 1 },
    { field: "section_name", headerName: "Sec", flex: 0.5 },
    { field: "father_details", headerName: "Father Name", flex: 1 },
    { field: "amount_paid", headerName: "Total", flex: 1 },
    { field: "user", headerName: "Collected By", flex: 1 },
  ];

  const handleGeneratePDF = async () => {
    try {
      setGeneratePdf(true);
      console.log(`tableRefs.current.length: ${tableRefs.current.length}`);
      if (!tableRefs.current || tableRefs.current.length === 0) {
        console.error("No table elements found!");
        return;
      }

      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 200; // A4 width in mm minus margins

      for (let i = 0; i < tableRefs.current.length; i++) {
        //@ts-ignore
        const tableElement = tableRefs.current[i]?.current;
        if (!tableElement) continue; // Skip if ref is missing

        try {
          const canvas = await html2canvas(tableElement, { scale: 4 }); // Higher scale for better quality
          const imgData = canvas.toDataURL("image/png");
          const imgHeight = (canvas.height * imgWidth) / canvas.width; // Maintain aspect ratio

          if (i > 0) pdf.addPage(); // Add new page for each receipt
          pdf.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight);
        } catch (error) {
          console.error(`Error generating PDF for page ${i + 1}:`, error);
        }
      }

      window.open(pdf.output("bloburl"), "_blank");
    } catch (error) {
    } finally {
      setGeneratePdf(false);
    }
  };

  const JSX = () => {
    if (!tableRefs.current[0])
      //@ts-ignore
      tableRefs.current[0] = React.createRef();

    return (
      <Box
        display="flex"
        ref={tableRefs.current[0]}
        justifyContent="center"
        alignItems="center"
        // minHeight="100vh"
        bgcolor="grey.100"
        width={"80vw"}
        p={1}
      >
        <Box
          // maxWidth={800}
          width="80%"
          bgcolor="white"
          border={2}
          borderColor="black"
          p={2}
        >
          {/* Header */}
          {/* <Box textAlign="right" mb={2}>
            <Typography fontWeight="bold">
              {feesData?.length || "NA"}
            </Typography>
          </Box> */}

          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            mb={0}
          >
            <Grid item mt={0}>
              <img
                src="\img\vpm_gns_logo.png"
                width={100}
                height={80}
                alt="School Logo"
              />
            </Grid>
            <Grid item xs textAlign="center" mr={8}>
              <Typography
                variant="h4"
                fontWeight="bold"
                textTransform="uppercase"
                fontSize={"2.5em"}
                sx={{ fontFamily: "Alien Invader" }}
              >
                V.P.M Gyan Niketan School
              </Typography>
              <Typography variant="body1" mt={0} fontWeight="bold">
                BAIRIA, P.O. SUDNA, P.S DALTONGANJ, PALAMU, JH
              </Typography>

              <Typography variant="h6" fontWeight="bold" mt={0}>
                Session : {`(${currentSessionAY})`}
              </Typography>
            </Grid>
          </Grid>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems={"center"}
            borderBottom={4}
            borderColor="black"
            py={1}
            mb={1}
          />

          <Box
            display="flex"
            flexDirection={"column"}
            justifyContent="center"
            alignItems={"center"}
            border={"2px solid black"}
            borderColor="black"
            py={1}
            mb={2}
            width={"100%"}
          >
            <Typography variant="h5">
              Fees Collection Between{" "}
              <strong>{`${reportDate.start_date} And ${reportDate.end_date}`}</strong>{" "}
              At School
            </Typography>
            <Box
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
              alignItems={"center"}
              py={0}
              mt={1}
              width={"98%"}
            >
              <Typography variant="body1">
                Collected By: All Counters
              </Typography>
              <Typography variant="body1">
                Fee Type: All Types of Collection
              </Typography>
            </Box>
          </Box>

          {/* Fees Table */}
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <StyledTableCell>
                    <strong>S No.</strong>
                  </StyledTableCell>
                  <StyledTableCell>
                    <strong>Rcpt No.</strong>
                  </StyledTableCell>
                  <StyledTableCell>
                    <strong>Fee Admin</strong>
                  </StyledTableCell>
                  <StyledTableCell>
                    <strong>Student Name</strong>
                  </StyledTableCell>
                  <StyledTableCell>
                    <strong>Adm No.</strong>
                  </StyledTableCell>
                  <StyledTableCell>
                    <strong>Class/Sec</strong>
                  </StyledTableCell>
                  <StyledTableCell>
                    <strong>Father Name</strong>
                  </StyledTableCell>
                  <StyledTableCell>
                    <strong>Total</strong>
                  </StyledTableCell>
                  <StyledTableCell>
                    <strong>Remark</strong>
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {applications.map((record: any, index: any) => (
                  <TableRow key={index}>
                    <StyledTableCell>{index + 1}</StyledTableCell>
                    <StyledTableCell>
                      {record?.fee_receipt_sequence_number
                        ?.toString()
                        .padStart(6, "0") || record.receipt_no}{" "}
                      {record.payment_status === "Cancelled" && (
                        <strong>(CANCELLED)</strong>
                      )}
                    </StyledTableCell>
                    <StyledTableCell>{record.user}</StyledTableCell>
                    <StyledTableCell>{record.personal_details}</StyledTableCell>
                    <StyledTableCell>
                      {record.admission_id?.toString().padStart(5, "0")}
                    </StyledTableCell>
                    <StyledTableCell>{`${record.class_name}-${record.section_name}`}</StyledTableCell>
                    <StyledTableCell>{record.father_details}</StyledTableCell>
                    <StyledTableCell>{record.amount_paid}</StyledTableCell>
                    <StyledTableCell>
                      {record.cancellation_remark
                        ? record.cancellation_remark
                        : record.remarks}
                    </StyledTableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <Box
            display="flex"
            flexDirection={"column"}
            justifyContent="flex-start"
            alignItems={"center"}
            mt={-4}
          >
            <Typography fontWeight="bold" variant="body1" mt={7} mb={2}>
              COLLECTION STATEMENT SUMMARY
            </Typography>
            <Stack spacing={0} sx={{ width: "100%" }}>
              {Object.entries(totalAmountByUser).map(
                ([key, value], index, arr) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between", // Align key left and value right
                      padding: "4px 0",
                      borderBottom: "1px solid black",
                    }}
                  >
                    <Typography variant="body1" mt={0}>
                      {`Collected By ${key}`}
                    </Typography>
                    <Typography variant="body1" mt={0}>
                      {`Rs.${value}`}
                    </Typography>
                  </Box>
                )
              )}
              {/* <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between", // Align key left and value right
                  padding: "4px 0",
                  borderBottom: "1px solid black",
                }}
              >
                <Typography fontWeight="bold" variant="body1" mt={0}>
                  Total Cancelled Receipt:
                </Typography>
                <Typography fontWeight="bold" variant="body1" mt={0}>
                  value
                </Typography>
              </Box> */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between", // Align key left and value right
                  padding: "4px 0",
                  borderBottom: "1px solid black",
                }}
              >
                <Typography variant="body1" mt={0}>
                  Total Amount Collected in Figures:
                </Typography>
                <Typography variant="body1" mt={0}>
                  {`Rs.${totalAmount}`}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between", // Align key left and value right
                  padding: "4px 0",
                  borderBottom: "1px solid black",
                }}
              >
                <Typography variant="body1" mt={0}>
                  Total Amount Collected in Words:
                </Typography>
                <Typography variant="body1" mt={0}>
                  {`RUPEES ${toWords(totalAmount).toUpperCase()} ONLY`}
                </Typography>
              </Box>
            </Stack>
          </Box>

          {/* Signature */}
          <Box
            display="flex"
            flexDirection={"row"}
            justifyContent="space-between"
            alignItems={"center"}
            mt={1}
          >
            <Typography variant="body1" mt={7}>
              Prepared By
            </Typography>
            <Typography variant="body1" mt={7}>
              Checked By
            </Typography>
            <Typography variant="body1" mt={7}>
              Accountant
            </Typography>
            <Typography variant="body1" mt={7}>
              Principal Signature
            </Typography>
          </Box>
        </Box>
      </Box>
    );
  };

  return (
    <>
      <ToastSnackbar ref={snackbarRef} />
      <Box
        display={"flex"}
        flexDirection={"row"}
        justifyContent={"space-between"}
        p={2}
        pb={0}
        gap={1}
      >
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"flex-start"}
          p={2}
          pb={0}
          gap={1}
        >
          <MyCustomButton
            variant="contained"
            startIcon={<ArrowLeftIcon />}
            onClick={() => navigate("..")}
          >
            Go Back
          </MyCustomButton>
          <MyCustomButton
            variant="contained"
            startIcon={<HomeIcon />}
            onClick={() => navigate("/home")}
          >
            Home
          </MyCustomButton>
        </Box>
      </Box>

      <Box
        display={"flex"}
        flexDirection={"column"}
        p={2}
        pt={0}
        height="auto"
        width="auto"
      >
        <Box
          display={"flex"}
          flexDirection={"column"}
          p={2}
          pt={0}
          height="auto"
          justifyContent={"center"}
          alignItems={"center"}
          width={"90vw"}
        >
          <Typography variant="h6" alignSelf={"center"}>
            <strong>Select Start Date & End End To Fetch Report</strong>
          </Typography>
          <form
            onSubmit={handleSubmit(FetchReportHandler)}
            onReset={onResetHandler}
          >
            <Box
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"space-evenly"}
              gap={3}
              mt={2}
              width="70vw"
            >
              <Box
                display={"flex"}
                flexDirection={"row"}
                justifyContent={"flex-start"}
                alignItems={"center"}
                gap={1}
                mt={1}
              >
                <Typography variant="body2" pt={0}>
                  <strong>Start Date: </strong>
                </Typography>
                <ControlledTextField
                  name="start_date"
                  control={control}
                  errors={errors}
                  type="date"
                  sx={{ width: "60%" }}
                  required
                />
              </Box>

              <Box
                display={"flex"}
                flexDirection={"row"}
                justifyContent={"flex-start"}
                alignItems={"center"}
                gap={1}
                mt={1}
              >
                <Typography variant="body2" pt={0}>
                  <strong>End Date: </strong>
                </Typography>
                <ControlledTextField
                  name="end_date"
                  control={control}
                  errors={errors}
                  type="date"
                  sx={{ width: "60%" }}
                  required
                />
              </Box>
              <MyCustomButton
                variant="contained"
                onClick={() => {
                  setGetHeadWiseReport(false);
                }}
                type="submit"
                startIcon={
                  fetchingReport ? <CircularProgress size={20} /> : null
                }
                disabled={fetchingReport}
                sx={{
                  alignSelf: "center",
                  height: "70%",
                  width: "20%",
                }}
              >
                {fetchingReport ? "" : "Collection Report"}
              </MyCustomButton>
              <MyCustomButton
                variant="contained"
                onClick={() => {
                  setGetHeadWiseReport(true);
                }}
                type="submit"
                startIcon={
                  gettingReport ? <CircularProgress size={20} /> : null
                }
                disabled={gettingReport}
                sx={{
                  alignSelf: "center",
                  height: "70%",
                  width: "20%",
                }}
              >
                {gettingReport ? "" : "Head Wise Report"}
              </MyCustomButton>
              <MyCustomButton
                variant="contained"
                type="reset"
                sx={{
                  alignSelf: "center",
                  height: "70%",
                  width: "20%",
                }}
              >
                Clear
              </MyCustomButton>
            </Box>
          </form>
          {/* <DataGrid
            rows={applications}
            columns={columns}
            rowHeight={40}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            pageSizeOptions={[50, 100, 150]}
            checkboxSelection={false}
            disableRowSelectionOnClick
            slots={{
              toolbar: GridToolbar,
              noRowsOverlay: () => <CustomNoRowsOverlay />,
            }}
            slotProps={{ toolbar: { showQuickFilter: true } }}
            sx={{
              width: "80vw",
              maxWidth: "90vw",
              height: "70vh", // Ensures sufficient height
              minHeight: "350px", // Ensures the No Data message is always visible properly
              marginTop: "15px",

              "& .MuiDataGrid-row:hover": {
                transform: "scale(1)",
                backgroundColor: "#f5f5f5",
                "& .MuiDataGrid-cell": {
                  color: "#2E186A",
                  fontWeight: "bold",
                },
              },
              "& .MuiDataGrid-row.Mui-selected": {
                backgroundColor: "#f0f0f0",
              },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#1e88e5",
                // fontFamily: "Motiva Sans Bold",
                color: "#2e186a",
                fontSize: "1rem",
                borderBottom: "2px solid #fff",
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                textOverflow: "clip",
                whiteSpace: "normal",
                lineHeight: "1",
              },
              "& .MuiDataGrid-columnHeader": {
                padding: "0px 10px",
              },
            }}
          /> */}

          {applications && applications.length > 0 && (
            <>
              <JSX />
              <MyCustomButton
                onClick={handleGeneratePDF}
                variant="contained"
                disabled={generatePdf}
                startIcon={
                  generatePdf ? <CircularProgress size={20} /> : undefined
                }
                sx={{
                  marginTop: 2,
                  marginBottom: 4,
                }}
              >
                {generatePdf ? "...Wait" : "Get PDF"}
              </MyCustomButton>
            </>
          )}
        </Box>
      </Box>
    </>
  );
};

export default FeeCollection;
